export default {
  methods: {
    deleteclass: function () {
      if (!window.app.f7.online) {
        window.app.f7.dialog.alert('Device Offline!');
        return;
      }
      if (!gapi.auth2.getAuthInstance().isSignedIn.get()) {
        window.app.f7.dialog.alert('Please Sign In!');
        return;
      }
      window.removeIndex = parseInt(this.$route.query.index, 10);
      console.log(window.removeIndex);
      var app = this.$app;
      app.dialog.confirm('This will delete class from devices (BUT NOT FROM GOOGLE SHEETS). Proceed?', function () {
        let x = JSON.parse(localStorage.getItem('rooms'));
        localStorage.setItem('prevElems', JSON.stringify(x.length));
        console.log(window.removeIndex);
        x.splice(window.removeIndex, 1);
        console.log(x);
        localStorage.setItem('rooms', JSON.stringify(x));
        localStorage.setItem('lastUpdate', JSON.stringify(new Date()));
        window.app.f7.methods.syncAppData();
        window.removeIndex = undefined;
        app.dialog.alert('Done!');
        window.app.f7.views.current.router.back();
      });
    },
    openInSheets: function () {
      var i = parseInt(this.$route.query.index, 10);
      var app = this.$app;
      let x = JSON.parse(localStorage.getItem('rooms'));
      window.open(x[i].url);
    },
    renameClass: function () {
      if (!window.app.f7.online) {
        window.app.f7.dialog.alert('Device Offline!');
        return;
      }
      if (!gapi.auth2.getAuthInstance().isSignedIn.get()) {
        window.app.f7.dialog.alert('Please Sign In!');
        return;
      }
      window.i = parseInt(this.$route.query.index, 10);
      var app = this.$app;
      app.dialog.prompt('Type New Name', 'Rename Class', function (text) {
        var x = JSON.parse(localStorage.getItem('rooms'));
        x[window.i]['alias'] = text;
        window.i = null;
        localStorage.setItem('rooms', JSON.stringify(x));
        localStorage.setItem('lastUpdate', JSON.stringify(new Date()));
        window.app.f7.methods.syncAppData();
      });
    }
  },
  id: '39ea9edd90',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page" data-name="classPage">\n      <div class="navbar">\n        <div class="navbar-bg"></div>\n        <div class="navbar-inner sliding">\n          <div class="left">\n            <a href="#" class="link back">\n              <i class="icon icon-back"></i>\n              <span class="if-not-md">Back</span>\n            </a>\n          </div>\n          <div class="title"></div>\n        </div>\n      </div>\n      <div class="page-content">\n        <div class="block-title">';
      r += c(ctx_1.$route.query.title, ctx_1);
      r += '</div>\n        <div class="block block-strong">\n            <p class="row">\n                <a href="/attendance/';
      r += c(ctx_1.$route.params.id, ctx_1);
      r += '/?bonus=false" class="col button button-large button-fill button-raised color-green">Take Attendance</a>\n            </p>\n            <p class="row">\n                <a href="#" class="col button button-large button-fill button-raised" @click="renameClass">Rename Class</a>\n                <a href="#" class="col button button-large button-fill button-raised color-red" @click="deleteclass">Delete Class</a>\n            </p>\n            <a href="#" class="col button button-large button-fill button-raised color-green" @click="openInSheets">Open Google Sheets</a>\n            <p class="row">\n              <a href="/attendance/';
      r += c(ctx_1.$route.params.id, ctx_1);
      r += '/?bonus=true" class="col button button-large button-raised">Bonus Attendance</a>\n            </p>\n            <!-- ';
      r += c(ctx_1.$route.query.index, ctx_1);
      r += ' ';
      r += c(ctx_1.$route.query.title, ctx_1);
      r += '\n            ';
      r += c(ctx_1.$route.params.id, ctx_1);
      r += '  -->\n        </div>\n      </div>\n    </div>\n  ';
      return r;
    }(this);
  },
  styleScoped: false
};